import { createApp, nextTick } from "vue"
import { createPinia } from "pinia"

import App from "./App.vue"
import router from "./router"

// ------------------------------------
// 🎨 Styles
// ------------------------------------
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { Tooltip } from "bootstrap"

import "@fortawesome/fontawesome-free/css/all.min.css"
import "@/css/main.css"

// ------------------------------------
// 🚀 App Initialisierung
// ------------------------------------
const app = createApp(App)

app.use(createPinia())
app.use(router)

// ------------------------------------
// 🧩 Globale Bootstrap Tooltips
// ------------------------------------
app.mixin({
  mounted() {
    nextTick(() => {
      this.$el
        ?.querySelectorAll?.('[data-bs-toggle="tooltip"]')
        .forEach(el => {
          if (!el._tooltip) {
            el._tooltip = new Tooltip(el)
          }
        })
    })
  },
  updated() {
    nextTick(() => {
      this.$el
        ?.querySelectorAll?.('[data-bs-toggle="tooltip"]')
        .forEach(el => {
          if (!el._tooltip) {
            el._tooltip = new Tooltip(el)
          }
        })
    })
  }
})

app.mount("#app")
